var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tab-groups"}},[_c('GroupEditorModal',{ref:"group-editor-modal",attrs:{"group_id":_vm.group_id},on:{"created":_vm.group_created}}),_c('GroupTable',{attrs:{"items":_vm.groups},on:{"delete":_vm.group_delete_clicked,"create":_vm.group_create_clicked,"selected":_vm.group_select_clicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }